/* eslint-disable jsx-a11y/media-has-caption */
// /* eslint-disable jsx-a11y/no-static-element-interactions */
// /* eslint-disable react/jsx-key */
// /* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
// import Swiper from 'react-id-swiper';
import style from './app.module.css';
import { isInApp, reportUserBehavior } from '../../utils/common';
import { useConfig } from './hook';
import { Swiper, SwiperSlide } from 'swiper/react';
// import ReactAudioPlayer from './components/audio_player';
import Chapter1 from './components/chapter1';
import Chapter2 from './components/chapter2';
import Chapter3 from './components/chapter3';
import Chapter4 from './components/chapter4';
import Chapter5 from './components/chapter5';
import Chapter6 from './components/chapter6';
import Chapter7 from './components/chapter7';
import Chapter8 from './components/chapter8';
import Chapter9 from './components/chapter9';
import Chapter10 from './components/chapter10';
import Chapter11 from './components/chapter11';
import Empty from '../../components/empty';
import emptyIcon from '@assets/queuing.png';

import PopupModel from './components/popup-model/index';
// import ShareModel from './components/share-model/index';
// Import Swiper styles
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';

// import Music from '../../assets/yearly-report/yearly-report-bg-music.mp3';
// import Music from '@assets/yearly-report/yearly-report-bg-music.mp3';

console.log('lhhh', isInApp());
const pageHeight = document.body.clientHeight + 10;

const App = () => {
  const {
    setSwiperFun,
    uid,
    loading,
    swiperController,
    yearlyReportFlag,
    // setYearlyReportFlag,
    yearlyData,
    showPopupModel,
    popuModelTitle,
    confirmText,
    cancelText,
    popuModelContent,
    copyrightContent,
    popupModelType,
    showInstructionModel,
    // closeShareModel,
    setPosterFun,
    cancelCb,
    confirmFun,
    // shareWayFun,
    shareModel,
    posterData,
    showAgreedModel,
    agreedFlag,
    audioRef,
    setAudioStatus,
    audioFlag,
    setNextStatus,
    nextStatus,
    btnSeconds,
    copyrightFlag,
    setWhiteIcon,
    whiteIconFlag
  } = useConfig();

  const renderHomePage = () => {
    if (!yearlyData || loading) {
      return (
        <div
          style={{ backgroundColor: '#ffffff', width: '100%', height: '100%' }}
        >
          <Empty
            text={loading ? '加载中...' : '加载数据失败，请稍后重试'}
            icon={emptyIcon}
            retry={!loading}
          />
        </div>
      );
    }
    return (
      <div className={style.homeContainer}>
        <div className={style.headerBox}>
          {/* <div className={style.xpIconBox} /> */}
          <div className={style.titleBox}>
            <p className={style.blackHomeText}>
              小鹏超充陪你去看
              <br />
              更远的风景
            </p>
            <p className={style.ordinaryBlackHomeText}>
              2021年车主年度充电报告
            </p>
          </div>
        </div>
        <div className={style.bottomBox}>
          <div
            className={style.openReportBtn}
            onClick={() => {
              showAgreedModel(0);
              // setYearlyReportFlag(true);
            }}
          >
            <p className={style.openText}>开启我的年度报告</p>
          </div>
          <div
            className={style.tipsBox}
            onClick={() => {
              showAgreedModel(1);
            }}
          >
            <p className={style.tipsText}>
              {agreedFlag ? '你已同意过' : null}
              <span className={style.agreementText}>《隐私声明》</span>
            </p>
          </div>
        </div>
      </div>
    );
  };

  const renderPageController = (item, index) => {
    switch (item.page) {
      case 'p1':
        return (
          <SwiperSlide key={index}>
            <Chapter1 data={item} setInstructionModel={showInstructionModel} />
          </SwiperSlide>
        );
      case 'p2':
        return (
          <SwiperSlide key={index}>
            <Chapter2 data={item} setInstructionModel={showInstructionModel} />
          </SwiperSlide>
        );
      case 'p3':
        return (
          <SwiperSlide key={index}>
            <Chapter3 data={item} setInstructionModel={showInstructionModel} />
          </SwiperSlide>
        );
      case 'p4':
        return (
          <SwiperSlide key={index}>
            <Chapter4 data={item} setInstructionModel={showInstructionModel} />
          </SwiperSlide>
        );
      case 'p5':
        return (
          <SwiperSlide key={index}>
            <Chapter5 data={item} setInstructionModel={showInstructionModel} />
          </SwiperSlide>
        );
      case 'p6':
        return (
          <SwiperSlide key={index}>
            <Chapter6 data={item} setInstructionModel={showInstructionModel} />
          </SwiperSlide>
        );
      case 'p7':
        return (
          <SwiperSlide key={index}>
            <Chapter7 data={item} setInstructionModel={showInstructionModel} />
          </SwiperSlide>
        );
      case 'p8':
        return (
          <SwiperSlide key={index}>
            <Chapter8 data={item} setInstructionModel={showInstructionModel} />
          </SwiperSlide>
        );
      case 'p9':
        return (
          <SwiperSlide key={index}>
            <Chapter9
              data={item}
              setInstructionModel={showInstructionModel}
              setPoster={setPosterFun}
              posterData={posterData}
            />
          </SwiperSlide>
        );
      // case 'p10':
      //   return (
      //     <SwiperSlide key={index}>
      //       <Chapter10 data={item} setInstructionModel={showInstructionModel} />
      //     </SwiperSlide>
      //   );
      case 'p11':
        return (
          <SwiperSlide key={index}>
            <Chapter11 data={item} setInstructionModel={showInstructionModel} />
          </SwiperSlide>
        );
      default:
        return;
    }
  };

  const renderPoster = () => {
    return (
      <div className={style.posterBox}>
        <Chapter10 data={posterData[0]} />
      </div>
    );
  };

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (audioRef && audioRef.current && audioFlag) {
        audioRef.current.pause();
      }
    } else {
      setTimeout(() => {
        if (audioRef && audioRef.current && audioFlag) {
          audioRef.current.play();
        }
      }, 2000);
    }
  });

  // if (!yearlyData || loading) {
  //   return (
  //     <Empty
  //       text={loading ? '加载中...' : '加载数据失败，请稍后重试'}
  //       icon={emptyIcon}
  //       retry={!loading}
  //     />
  //   );
  // }
  return (
    <div className={!yearlyReportFlag ? style.homePage : style.reportPage}>
      <div
        className={
          audioFlag && !whiteIconFlag
            ? style.audioView
            : audioFlag && whiteIconFlag
              ? style.audioWhiteView
              : !audioFlag && whiteIconFlag
                ? style.audioCloseWhiteView
                : style.audioCloseView
        }
        // className={audioFlag ? style.audioView : style.audioCloseView}
        onClick={() => {
          // if (audioRef && audioRef.current) {
          //   // 增加回调来获取 onPlay 和 onPasue 的状态，记录一个 playing 的 flag，播放中，则调动 pause()
          //   // 参考源代码中增加 event 的方式 https://github.com/justinmc/react-audio-player/blob/master/src/index.tsx
          //   audioRef.current.play();
          // }
          setAudioStatus();
        }}
      >
        <audio
          autoPlay={false}
          loop={true}
          ref={audioRef}
          preload={'auto'}
          src={
            'https://s.xiaopeng.com/xp-charge/charge/report/year_report_bgm.mp3'
          }
        />
      </div>
      {yearlyReportFlag && (
        <Swiper
          height={pageHeight}
          // spaceBetween={pageHeight}
          // lazy={{
          //   loadPrevNext: true,
          //   loadPrevNextAmount: 2
          // }}
          // preloadImages={true}
          onSlidePrevTransitionStart={() => {
            console.log('slide pre');
            if (!nextStatus) {
              setNextStatus(true);
            }
          }}
          // onSliderMove={(swiper, event) => {
          //   console.log('slide onSliderMove');
          //   console.log(event);
          // }}
          // onSetTranslate={(swipter, num) => {
          //   console.log(num);
          //   console.log(document.documentElement.clientHeight)
          // }}
          direction={'vertical'}
          pagination={{ clickable: true }}
          // scrollbar={{ draggable: true }}
          // slidesPerView={1} // 显示的数目
          onSlideChange={swiper => {
            const index = swiper.realIndex;
            const item = yearlyData[index];
            console.log(`slide change`);
            console.log(
              'chapter_page_' + item.page + ',chapter_status_' + item.status
            );
            if (item.page === 'p4') {
              setWhiteIcon(true);
            } else {
              setWhiteIcon(false);
            }
            // 埋点-页面切换点击
            reportUserBehavior({
              appid: 'N005',
              so: 'N005001',
              ch: '4_0+',
              ut: '',
              mcode:
                'chapter_page_' +
                item.page +
                ',chapter_status_' +
                item.status +
                ',uid_' +
                uid,
              pa:
                'chapter_page_' +
                item.page +
                ',chapter_status_' +
                item.status +
                ',uid_' +
                uid
            });
          }}
          onReachEnd={() => {
            console.log('slide changeEnd');
            setNextStatus(false);
          }}
          onSwiper={swiper => {
            console.log('swiper');
            console.log(swiper);
            setSwiperFun(swiper);
          }}
        >
          {yearlyData &&
            yearlyData.map((item, index) => {
              return renderPageController(item, index);
            })}
        </Swiper>
      )}
      {/* 查看下一页 */}
      {yearlyReportFlag && !shareModel && (
        <div
          className={style.nextPageStyle}
          onClick={() => {
            // console.log(swiperController.activeIndex);
            swiperController.slideNext();
            if (!nextStatus) {
              swiperController.slideTo(0, 1000, false);
              setNextStatus(true);
            }
          }}
        >
          {!nextStatus && <p className={style.nextPageText}>重新查看</p>}
          {/* <p className={style.nextPageText}>
            {nextStatus ? '查看下一页' : '重新查看'}
          </p> */}
          {nextStatus && (
            <div
              className={
                whiteIconFlag ? style.nextIconWhiteStyle : style.nextIcon
              }
            />
          )}
        </div>
      )}
      {!yearlyReportFlag && renderHomePage()}
      {/* 弹窗 */}
      {showPopupModel && (
        <PopupModel
          content={popuModelTitle}
          type={popupModelType}
          tip={popuModelContent}
          copyright={copyrightContent}
          copyrightFlag={copyrightFlag}
          seconds={btnSeconds}
          cancelText={cancelText}
          confirmText={confirmText}
          confirmCbk={confirmFun}
          cancelCbk={cancelCb}
        />
      )}
      {/* 分享弹窗 */}
      {/* {!!posterData && shareModel && (
        <ShareModel
          shareWay={shareWayFun}
          data={posterData}
          onCloseShareModel={closeShareModel}
        />
      )} */}
      {posterData && !yearlyReportFlag && renderPoster()}
    </div>
  );
};

export default App;
